import MuiDialogContentText from "@mui/material/DialogContentText";
const DialogContentText = MuiDialogContentText;
export default DialogContentText;
